import { apiRequest } from '../../lib/api.js';

export function renderCustomerDocuments() {
    return `
    <section class="page-header" style="background: var(--color-surface-warm);">
      <div class="container">
        <h1 class="page-title">My Documents</h1>
        <p class="page-subtitle">Access your project files, designs, and contracts</p>
      </div>
    </section>
    <section style="padding: var(--space-10) 0 var(--space-20);">
      <div class="container" style="max-width:900px;">
        <div id="docs-list" style="display:flex;flex-direction:column;gap:var(--space-6);">
          <div style="text-align:center;padding:var(--space-8);color:var(--color-text-muted);">Loading documents...</div>
        </div>
      </div>
    </section>
  `;
}

export function initCustomerDocuments() {
    async function load() {
        try {
            const data = await apiRequest('/projects');
            const projects = data.data || [];
            const container = document.getElementById('docs-list');

            if (!projects.length) {
                container.innerHTML = `
          <div style="text-align:center;padding:var(--space-16);background:var(--color-surface);border-radius:var(--radius-xl);border:1px solid var(--color-border);">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-muted)" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/></svg>
            <h3 style="margin:var(--space-4) 0 var(--space-2);">No Documents Yet</h3>
            <p style="color:var(--color-text-muted);">Documents will appear here once your project begins.</p>
          </div>
        `;
                return;
            }

            // Show project files grouped by project
            let hasAnyFiles = false;
            const html = projects.map(p => {
                const files = p.files || [];
                if (!files.length) return '';
                hasAnyFiles = true;

                const fileIcons = {
                    pdf: '📄', image: '🖼️', doc: '📝', design: '🎨', contract: '📋'
                };

                return `
          <div style="background:var(--color-surface);border-radius:var(--radius-xl);border:1px solid var(--color-border);overflow:hidden;">
            <div style="padding:var(--space-4) var(--space-6);background:var(--color-surface-warm);border-bottom:1px solid var(--color-border);">
              <h3 style="margin:0;font-size:16px;">${p.title}</h3>
              <p style="margin:2px 0 0;font-size:12px;color:var(--color-text-muted);">${files.length} file${files.length !== 1 ? 's' : ''}</p>
            </div>
            <div style="padding:var(--space-4) var(--space-6);">
              ${files.map(f => {
                    const ext = (f.file_name || '').split('.').pop().toLowerCase();
                    const icon = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext) ? fileIcons.image : ext === 'pdf' ? fileIcons.pdf : fileIcons.doc;
                    return `
                  <div style="display:flex;align-items:center;gap:var(--space-3);padding:var(--space-3) 0;border-bottom:1px solid var(--color-border-light);">
                    <span style="font-size:24px;">${icon}</span>
                    <div style="flex:1;min-width:0;">
                      <p style="margin:0;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${f.file_name || 'Document'}</p>
                      <p style="margin:2px 0 0;font-size:11px;color:var(--color-text-muted);">${f.file_type || ext.toUpperCase()} · ${new Date(f.created_at).toLocaleDateString()}</p>
                    </div>
                    ${f.file_url ? `<a href="${f.file_url}" target="_blank" class="btn btn-sm btn-outline">Download</a>` : ''}
                  </div>
                `;
                }).join('')}
            </div>
          </div>
        `;
            }).join('');

            container.innerHTML = hasAnyFiles ? html : `
        <div style="text-align:center;padding:var(--space-12);background:var(--color-surface);border-radius:var(--radius-xl);border:1px solid var(--color-border);">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-muted)" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/></svg>
          <h3 style="margin:var(--space-4) 0 var(--space-2);">No Documents Uploaded Yet</h3>
          <p style="color:var(--color-text-muted);">Your designer will upload project files as your project progresses. Check back soon!</p>
        </div>
      `;
        } catch (e) {
            document.getElementById('docs-list').innerHTML = `
        <div style="text-align:center;padding:var(--space-8);color:var(--color-error);">
          <p>Please log in to view documents.</p>
          <a href="/login" class="btn btn-primary" style="margin-top:var(--space-4);">Login</a>
        </div>
      `;
        }
    }
    load();
}
